// src/components/Header.jsx
import React from "react";
import { useState, useEffect } from "react"; // 若已引入可略
import { Link, NavLink } from "react-router-dom";

const NAV_ITEMS = [
  { label: "首頁", href: "/" },
  { label: "醫療團隊", href: "/team" },
  { label: "看診進度", href: "/visitprogress" },
  { label: "門診時刻表", href: "/schedule" },
  { label: "最新消息", href: "/education" },
  { label: "聯繫我們", href: "/contact" },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const close = () => setMenuOpen(false);
    window.addEventListener("resize", close);
    return () => window.removeEventListener("resize", close);
  }, []);

  return (
    <header className="header">
      <div className="header-inner">
        <Link
          className="brand"
          to="/"
          aria-label="Physian 首頁"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <Logo />
          <img
            className="brand-wordmark"
            src="/icons/straight-logo-3.png"
            alt="啟鐘耳鼻喉科診所"
            loading="eager"
            decoding="async"
          />
        </Link>
        <button
          className="nav-menu-btn"
          aria-label="開啟選單"
          aria-expanded={menuOpen}
          aria-controls="mobile-nav"
          onClick={() => setMenuOpen((v) => !v)}
        >
          {" "}
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
          {/* <p>網頁導覽</p> */}
        </button>

        {/* 桌機版導覽（水平排列） */}
        <nav className="nav-links-desktop" aria-label="主導覽">
          {NAV_ITEMS.map((i) =>
            i.href.startsWith("/") ? (
              <NavLink
                key={i.label}
                to={i.href}
                className={({ isActive }) =>
                  "nav-link" + (isActive ? " nav-link-active" : "")
                }
              >
                {i.label}
              </NavLink>
            ) : (
              <a key={i.label} className="nav-link" href={i.href}>
                {i.label}
              </a>
            )
          )}
        </nav>

        {/* 手機版導覽（下拉） */}
        <nav
          id="mobile-nav"
          className={`nav-links-mobile ${menuOpen ? "open" : ""}`}
          aria-label="主導覽（手機）"
        >
          {NAV_ITEMS.map((i) =>
            i.href.startsWith("/") ? (
              <NavLink
                key={i.label}
                to={i.href}
                className={({ isActive }) =>
                  "nav-link" + (isActive ? " nav-link-active" : "")
                }
                onClick={() => setMenuOpen(false)} // 點了就關選單
              >
                {i.label}
              </NavLink>
            ) : (
              <a
                key={i.label}
                className="nav-link"
                href={i.href}
                onClick={() => setMenuOpen(false)}
              >
                {i.label}
              </a>
            )
          )}
        </nav>
      </div>
    </header>
  );
}

function Logo() {
  return (
    <img
      src="/icons/square-logo.png"
      alt="啟鐘診所 Logo"
      className="logo"
      style={{ height: "40px" }} // 可依需求調整大小
    />
  );
}
